
let observers = [];

function intersectionCallback(entries){
    entries.forEach((entry) => {
      let intersectionAmount = entry.intersectionRatio;
      if(intersectionAmount > 0.65){
        entry.target.classList.add('active');
      }else{
        entry.target.classList.remove('active');
      }
    });
};

let careerCardRows = document.querySelectorAll(".section-career-card-row");
if (typeof(careerCardRows) != 'undefined' && careerCardRows != null) {  
    for (let i = 0; i < careerCardRows.length; i++) {
        let careerCards = careerCardRows[i].querySelectorAll(".career-card-scene");
        for (let x = 0; x < careerCards.length; x++) {
            careerCardIntersection(careerCards[x]);
        }
    }
}

function careerCardIntersection(card){
    let observerOptions = {
        //root: null,
        rootMargin: "-20% 0px -20% 0px",
        threshold: [],
    };

    let thresholdSets = [
        []
    ];

    for (let i = 0; i <= 1.0; i += 0.01) {
        thresholdSets[0].push(i);
    }

    observerOptions.threshold = thresholdSets[0];
    observers[i] = new IntersectionObserver(
        intersectionCallback,
        observerOptions
    );
    observers[i].observe(card);
}